/**
 * The two counts the rest of this feature composes with: how many tasks a
 * worker still owes (the home-screen line, T-14) and how many of those gate
 * punch OUT (the UI half of T-07 — the server guard is P4).
 *
 * `GET /me/tasks` already scopes to the caller's one current-or-next shift
 * (T-17: no shift, no tasks, no gate), so counting the array is enough — no
 * client-side shift matching.
 */
import type { Task } from '@saniplus/contracts';

export function pendingTasks(tasks: readonly Task[]): Task[] {
  return tasks.filter((task) => task.status === 'pending');
}

export function blockingTasks(tasks: readonly Task[]): Task[] {
  return tasks.filter((task) => task.status === 'pending' && task.blocksPunchOut);
}
